import { ConfigType } from './type';

export const CONFIG: ConfigType = {
  // ENV
  environment: 'staging',
  VITE_CURRENT_ENV: {
    isLocal: false,
    isDev: false,
    isStaging: true,
    isMock: false,
    isProd: false,
    isWeb: true,
    isMobile: false,
  },
  VITE_DOMAIN_URL: 'https://staging-dashboard.pncf.app',

  // API
  VITE_HOST_API: 'https://staging-api.pncf.app/b',
  VITE_PUBLIC_API: 'https://staging-api.pncf.app/b',
  VITE_ATH_API: 'https://staging-api.pncf.app/f/api',
  VITE_ATH_API_PUBLIC: 'https://staging-api.pncf.app/f/api',

  // # FIREBASE
  VITE_FIREBASE_API_KEY: 'AIzaSyCPlZtk0MXLxn0nCi0hcOvn76TtAdR6dXc',
  VITE_FIREBASE_AUTH_DOMAIN: 'pointcraft-inc-staging.firebaseapp.com',
  VITE_FIREBASE_PROJECT_ID: 'pointcraft-inc-staging',
  VITE_FIREBASE_STORAGE_BUCKET: 'pointcraft-inc-staging.firebasestorage.app',
  VITE_FIREBASE_MESSAGING_SENDER_ID: '223508625282',
  VITE_FIREBASE_APPID: '1:223508625282:web:1ae7e8ecf916d7b7ed419b',
  VITE_FIREBASE_MEASUREMENT_ID: 'G-TFXKHXGHVG',
  VITE_FIREBASE_REALTIME_DB_URL: 'https://pointcraft-inc-staging-default-rtdb.firebaseio.com/',
  VITE_STRIPE_PUBLISHABLE_KEY:
    'pk_test_51RQBC4Fl21qecZHmgVRcIODbNdBcQmnoWm9dgaaJYNg5JVUy5bswBUFbvmnNCyq2ztpar7AHizmhFzjjReRA4pYB004mcAZyGe',

  // MSC
  VITE_ASSETS_API: 'none',
  VITE_MAIN_TEST_ACCOUNT_NUMBER: '',
  DEFAULT_APP_VERSION_BECAUSE_OF_WEB: '22.22.22',
  VITE_APP_VERSION: '5.1.8',
  VITE_TILLED_PUBLISHABLE_KEY:
    'pk_mJb0BbXLxHedotoe7v7KQDP3gvCfmsvcjZmt1IUWzzr7unaiSvbt0De0supLmZRFenI7Cfy75WHtf69oLXRen2jJAccqvh0pKW5P',
  VITE_CUSTOMER_SERVICE_PHONE: '+1 (612) 473-5556',
  VITE_CUSTOMER_SERVICE_EMAIL: 'staging-support@point-craft.com',
  VITE_DEFAULT_TERMINAL_READER_LOCATION_ID: 'tml_GCbhdgwvhduGdG',
  VITE_SITE_ID: 'point_of_sale', // Default to POS, can be overridden by env var
  VITE_PAYMENT_LINK_BASE_URL: 'https://pay-staging.pointcraft.io',
  // VITE_SENTRY_DSN:
  //   'https://be107b84a8eb90636ac04044335b334a@o4507762364448768.ingest.us.sentry.io/4510622208229376',
  VITE_SENTRY_DSN: '',
  VITE_SENTRY_ORG: 'pointcraft-inc',
  VITE_SENTRY_PROJECT: 'pointcraft-frontend',
  VITE_GOOGLE_MAPS_API_KEY: 'AIzaSyBGvAaZtT_2By0nztK_6llBgHznmZNufFc', // Add your Google Maps API key here
  VITE_RECAPTCHA_SITE_KEY: '6Lfb4oIsAAAAAJpOvJRc_EzCTr2NdSKDnQ08TGJO',
  VITE_RECAPTCHA_ENABLED: true,
  VITE_USE_FIREBASE_EMULATORS: false,
  VITE_POINTPAY_PUBLIC_URL: 'https://pointpay-public-staging.web.app',
  VITE_POINTPAY_DASHBOARD_URL: 'https://app-staging.pointcraft.io',
};
